if ( typeof CartForm !== 'function' ) {
	class CartForm extends HTMLElement {

		constructor(){
			super();
			// Opdateringer køres én ad gangen i rækkefølge, så et ældre svar aldrig overskriver et nyere
			this.queue = Promise.resolve();
			this.pending = 0;
			this.checkoutQueued = false;
			this.ajaxifyCartItems();
		}

		ajaxifyCartItems(){

			this.form = this.querySelector('form');

			// "Gå til betaling" mens en ændring stadig kører: vent og send så — klikket må aldrig gå tabt
			if ( this.form ) {
				this.form.addEventListener('submit', e=>{
					if ( this.pending > 0 ) {
						e.preventDefault();
						this.checkoutQueued = true;
					}
				});
			}

			this.querySelectorAll('[data-js-cart-item]').forEach(item=>{

				const remove = item.querySelector('.remove');
				if ( remove ) {
					remove.dataset.href = remove.getAttribute('href');
					remove.setAttribute('href', '');
					remove.addEventListener('click', (e)=>{
						e.preventDefault();
						this.updateCartQty(item, 0);
					})
				}

				const qty = item.querySelector('.qty');
				if ( qty ) {
					// Opdatér først når kunden er færdig (Færdig/Gå/Enter eller tryk udenfor) — ikke midt i indtastningen
					qty.addEventListener('change', ()=>{
						const value = parseInt(qty.value);
						if ( isNaN(value) || value < 0 ) {
							qty.value = item.dataset.qty;
							return;
						}
						if ( value === parseInt(item.dataset.qty) ) return;
						this.updateCartQty(item, value);
					});
					// Enter/Gå må ikke sende formularen (den første knap i formularen var før minus på vare 1)
					qty.addEventListener('keydown', (e)=>{
						if ( e.key === 'Enter' || e.keyCode === 13 ) {
							e.preventDefault();
							qty.blur();
						}
					});
					qty.addEventListener('click', (e)=>{
						e.target.select();
					})
				}

			})

		}

		updateCartQty(item, newQty){
			// Linjens nøgle (ikke linjenummer), så den rigtige vare ændres, selv hvis kurven har ændret sig imens
			const key = item.dataset.id;
			const line = parseInt(item.dataset.line);
			this.pending++;
			this.setProcessing(true);
			this.queue = this.queue.then(()=>this.sendCartChange(key, line, newQty));
			return this.queue;
		}

		setProcessing(state){
			if ( this.form ) this.form.classList.toggle('processing', state);
			const subtotal = document.getElementById('AjaxCartSubtotal');
			if ( subtotal ) subtotal.classList.toggle('cart-processing', state);
		}

		sendCartChange(key, line, newQty){

			let alert = null;

			if ( this.querySelector('.alert') ) {
				this.querySelector('.alert').remove();
			}

			const body = JSON.stringify(key ? { id: key, quantity: newQty } : { line: line, quantity: newQty });

			return fetch(KROWN.settings.routes.cart_change_url, {
					method: 'POST',
					headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' },
					body
				})
				.then(response => response.json())
				.then(response => {
					if ( response.status == 422 || response.status == 400 || response.status == 404 ) {
						// wrong stock logic alert
						alert = document.createElement('span');
						alert.classList.add('alert', 'alert--error');
						if ( typeof response.description === 'string' ) {
							alert.innerHTML = response.description;
						} else {
							alert.innerHTML = response.message;
						}
					}
					return fetch('?section_id=helper-cart');
				})
				.then(response => response.text())
				.then(text => {

					const sectionInnerHTML = new DOMParser().parseFromString(text, 'text/html');
					const cartFormInnerHTML = sectionInnerHTML.getElementById('AjaxCartForm').innerHTML;
					const cartSubtotalInnerHTML = sectionInnerHTML.getElementById('AjaxCartSubtotal').innerHTML;

					const cartItems = document.getElementById('AjaxCartForm');
					cartItems.innerHTML = cartFormInnerHTML;
					cartItems.ajaxifyCartItems();

					document.querySelectorAll('[data-header-cart-count]').forEach(elm=>{
						elm.textContent = cartItems.querySelector('[data-cart-count]').textContent;
					});
					document.querySelectorAll('[data-header-cart-total]').forEach(elm=>{
						elm.textContent = cartItems.querySelector('[data-cart-total]').textContent;
					});

					if ( alert !== null ) {
						this.form.prepend(alert);
					}

					document.getElementById('AjaxCartSubtotal').innerHTML = cartSubtotalInnerHTML;

					const event = new Event('cart-updated');
					this.dispatchEvent(event);

				})
				.catch(e => {
					console.log(e);
					let alert = document.createElement('span');
					alert.classList.add('alert', 'alert--error');
					alert.textContent = KROWN.settings.locales.cart_general_error;
					this.form.prepend(alert);
					// Vis kurvens faktiske tal igen, så felterne ikke står med en værdi der ikke blev gemt
					this.querySelectorAll('[data-js-cart-item]').forEach(item=>{
						const qty = item.querySelector('.qty');
						if ( qty ) qty.value = item.dataset.qty;
					});
				})
				.finally(() => {
					this.pending--;
					if ( this.pending > 0 ) {
						this.setProcessing(true);
						return;
					}
					this.setProcessing(false);
					if ( this.checkoutQueued ) {
						this.checkoutQueued = false;
						const checkout = document.getElementById('CheckOut');
						if ( checkout && this.form && this.querySelectorAll('[data-js-cart-item]').length ) {
							this.form.requestSubmit ? this.form.requestSubmit(checkout) : checkout.click();
						}
					}
				});
		}

	}


  if ( typeof customElements.get('cart-form') == 'undefined' ) {
		customElements.define('cart-form', CartForm);
	}

}

if ( typeof CartProductQuantity !== 'function' ) {

	class CartProductQuantity extends HTMLElement {
		constructor(){
			super();
			this.querySelector('.qty-minus').addEventListener('click', this.changeCartInput.bind(this));
			this.querySelector('.qty-plus').addEventListener('click', this.changeCartInput.bind(this));
		}
		changeCartInput(){
			setTimeout(()=>{
				const item = this.closest('[data-js-cart-item]');
				const value = parseInt(this.querySelector('.qty').value);
				if ( ! item || isNaN(value) || value === parseInt(item.dataset.qty) ) return;
				document.getElementById('AjaxCartForm').updateCartQty(item, value);
			}, 50);
		}
	}

  if ( typeof customElements.get('cart-product-quantity') == 'undefined' ) {
		customElements.define('cart-product-quantity', CartProductQuantity);
	}

}

// method for apps to tap into and refresh the cart

if ( ! window.refreshCart ) {

	window.refreshCart = () => {

		fetch('?section_id=helper-cart')
			.then(response => response.text())
			.then(text => {

			const sectionInnerHTML = new DOMParser().parseFromString(text, 'text/html');
			const cartFormInnerHTML = sectionInnerHTML.getElementById('AjaxCartForm').innerHTML;
			const cartSubtotalInnerHTML = sectionInnerHTML.getElementById('AjaxCartSubtotal').innerHTML;

			const cartItems = document.getElementById('AjaxCartForm');
			cartItems.innerHTML = cartFormInnerHTML;
			cartItems.ajaxifyCartItems();

			document.querySelectorAll('[data-header-cart-count]').forEach(elm=>{
				elm.textContent = cartItems.querySelector('[data-cart-count]').textContent;
			});
			document.querySelectorAll('[data-header-cart-total]').forEach(elm=>{
				elm.textContent = cartItems.querySelector('[data-cart-total]').textContent;
			})

			document.getElementById('AjaxCartSubtotal').innerHTML = cartSubtotalInnerHTML;
			if ( document.querySelector('[data-js-site-cart-sidebar]') ) {
				document.querySelector('[data-js-site-cart-sidebar]').show();
			}

			if ( document.querySelector('cart-recommendations') ) {
				document.querySelector('cart-recommendations').innerHTML = '';
				document.querySelector('cart-recommendations').generateRecommendations();
			}

		})

	}

}
